import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';
import _ from 'lodash';

export class AiMblListItem extends SearchModelBase {
    id: number = 0;
    closed: string = '';
    shipmentType: string = '';
    invStat: string = '';
    billStat: string = '';
    crDbStat: string = '';
    mawbNo: string = '';
    branch: string = '';
    refNo: string = '';
    hblStat: string = '';
    agentName: string = '';
    agentRefNo: string = '';
    lCode: string = '';
    firstEntry: string = '';
    dCode: string = '';
    discharge: string = '';
    etd: string | null = null;
    fromETD: string | null = null;
    toETD: string | null = null;
    entryDate: string | null = null;
    fromEntryDate: string | null = null;
    toEntryDate: string | null = null;
    eta: string | null = null;
    fromETA: string | null = null;
    toETA: string | null = null;
    smawbNo: string = '';
    fltNo: string = '';
    vendorName: string = '';
    postDate: string | null = null;
    recognized: string = '';
    paidStatus: string = '';
    paidDate: string | null = null;
    fromPaidDate: string | null = null;
    toPaidDate: string | null = null;
    status: string = '';
    createdAt: string|null = null;
    pimsLinkId: number = 0;

    // cloud
    cargoMode: string = '';
    carrierName: string = '';
    customsRlsd: boolean = false;
    atmeSent: boolean = false;
    customsHold: boolean = false;
    fLocationName: string = '';
    commodity: string = '';
    pkgs: number = 0;
    fromPkgs: number = 0;
    toPkgs: number = 0;
    grossWeight: number = 0;
    fromGrossWeight: number = 0;
    toGrossWeight: number = 0;
    chgWeight: number = 0;
    fromChgWeight: number = 0;
    toChgWeight: number = 0;
    lChgWeight: number = 0;
    fromLChgWeight: number = 0;
    toLChgWeight: number = 0;

    fromCreatedAt: string | null = null;
    toCreatedAt: string | null = null;
    updateDate: string | null = null;
    fromUpdateDate: string | null = null;
    toUpdateDate: string | null = null;
    updateBy: string = '';
    createBy: string = '';
    directBl: boolean = false;
    projectNo: string = '';
    
    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'R', width: 30, dataIndex: 'recognized', noNullOrEmptySearch: true, hiddenInColumnSetup: true}),
        XCol.Create({ col: 25, text: 'D/ID', width: 35, dataIndex: 'shipmentType', noNullOrEmptySearch: true}),
        
        // XCol.Create({ col: 6, text: 'Cargo', width: 160, dataIndex: 'cargoMode'}),
        XCol.Create({ col: 2, text: 'MAWB', width: 100, dataIndex: 'mawbNo'}),
        XCol.Create({ col: 3, text: 'BR', width: 40, dataIndex: 'branch', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 4, text: 'Ref. #', width: 100, dataIndex: 'refNo', defaultColumnFocus : true}),
        XCol.Create({ col: 5, text: 'HAWB(s)', width: 50, dataIndex: 'hblStat', noNullOrEmptySearch: true}),
        XCol.Create({ col: 6, text: 'Agent', width: 120, dataIndex: 'agentName'}),
        XCol.Create({ col: 7, text: 'Project ID', width: 100, dataIndex: 'projectNo'}),
        XCol.Create({ col: 8, text: 'Agent Ref.', width: 100, dataIndex: 'agentRefNo'}),
        XCol.Create({ col: 9, text: 'Departure', width: 60, dataIndex: 'lCode', align: XCol.XAlignType.Center}),
        // XCol.Create({ col: 14, text: 'ATME', width: 50, dataIndex: 'atmeSent', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        // XCol.Create({ col: 15, text: 'CC', width: 50, dataIndex: 'customsRlsd', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        // XCol.Create({ col: 16, text: 'CH', width: 50, dataIndex: 'customsHold', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        //XCol.Create({ col: 17, text: 'Carrier', width: 120, dataIndex: 'carrierName'}),
        XCol.Create({ col: 10, text: 'First Entry', width: 60, dataIndex: 'firstEntry', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 11, text: 'Destination', width: 60, dataIndex: 'dCode', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 12, text: 'ETD', width: 75, dataIndex: 'etd', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 13, text: 'Entry Date', width: 75, dataIndex: 'entryDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 14, text: 'ETA', width: 75, dataIndex: 'eta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 15, text: 'Freight Location', width: 120, dataIndex: 'fLocationName'}),
        XCol.Create({ col: 16, text: 'PKG(s)', width: 80, dataIndex: 'pkgs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true}),
        XCol.Create({ col: 17, text: 'KGS', width: 80, dataIndex: 'chgWeight', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true}), 
        XCol.Create({ col: 18, text: 'LBS', width: 80, dataIndex: 'lChgWeight', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true}),
        XCol.Create({ col: 19, text: 'Commodity', width: 120, dataIndex: 'commodity', visible: false}),
        XCol.Create({ col: 20, text: 'Flight', width: 60, dataIndex: 'fltNo'}),
        // XCol.Create({ col: 29, text: 'Sub MAWB No', width: 100, dataIndex: 'smawbNo', visible: false}),
        XCol.Create({ col: 21, text: 'Freight Vendor', width: 120, dataIndex: 'vendorName'}),
        XCol.Create({ col: 22, text: 'FrtChrg', width: 75, dataIndex: 'paidStatus'}),
        XCol.Create({ col: 23, text: 'Paid', width: 75, dataIndex: 'paidDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        
        XCol.Create({ col: 26, text: 'INV', width: 35, dataIndex: 'invStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false}),
        XCol.Create({ col: 27, text: 'BIL', width: 35, dataIndex: 'billStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false}),
        XCol.Create({ col: 28, text: 'CrDb', width: 35, dataIndex: 'crDbStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false}),
        
        XCol.Create({ col: 29, text: 'Create Date', width: 100, dataIndex: 'createdAt', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center, visible: false}),
        XCol.Create({ col: 30, text: 'Create by', width: 100, dataIndex: 'u1ID', visible: false}),
        XCol.Create({ col: 31, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center, visible: false}),
        XCol.Create({ col: 32, text: 'Update by', width: 100, dataIndex: 'u2ID', visible: false}),
    ];


    public static getExportCollection(useBranch: boolean): XCol.XExportColumn[] {
        let returnCloumns = _.cloneDeep(this.ExportCollection);
        if (!useBranch) returnCloumns = returnCloumns.filter(x => x.dataIndex !== 'branch');
        return returnCloumns;
    };
	
    public static OrderBy = { orderBy: AiMblListItem.prototype.createdAt, orderByAscending: false };

    public static formatData(data: AiMblListItem[]) {
        return data.map((d: AiMblListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        etd: {from: 'fromETD', to: 'toETD'},
        entryDate: {from: 'fromEntryDate', to: 'toEntryDate'},
        eta: {from: 'fromETA', to: 'toETA'},
        pkgs: {from: 'fromPkgs', to: 'toPkgs'},
        grossWeight: {from: 'fromGrossWeight', to: 'toGrossWeight'},
        chgWeight: {from: 'fromChgWeight', to: 'toChgWeight'},
        lChgWeight: {from: 'fromLChgWeight', to: 'toLChgWeight'},
        updateDate: {from: 'fromUpdateDate', to: 'toUpdateDate'},
        createdAt: {from: 'fromCreatedAt', to: 'toCreatedAt'},
        paidDate: {from: 'fromPaidDate', to: 'toPaidDate'},
    }
}
